import { SYSTEM_ENTITIES_GET_LIST } from 'apiRoutes';
import { SystemEntity } from 'domain/systemEntity/interfaces/SystemEntity';
import { useNavigate } from 'react-router-dom';
import { Button, HStack } from '@montel/montelpro-shared-components-v2';
import { useGetOnMount } from 'hooks/useGetOnMount';
import { systemEntitiesTableColumns } from 'components/systemEntities/SystemEntityTable/systemEntitiesTableColumns';
import { useMemo } from 'react';
import { Table } from 'components/tables/Table';

const SystemEntitiesList = () => {
	const { data: systemEntities, status } = useGetOnMount<SystemEntity[]>(
		`${SYSTEM_ENTITIES_GET_LIST}`,
	);

	const columns = useMemo(
		() => [
			systemEntitiesTableColumns.name(),
			systemEntitiesTableColumns.company(),
			systemEntitiesTableColumns.created(),
		],
		[systemEntities],
	);

	const navigate = useNavigate();

	return (
		<>
			<Table<SystemEntity>
				columns={columns}
				containerGap="xs"
				requestStatus={status}
				data={systemEntities}
				onRowClicked={(row: SystemEntity) => {
					navigate(`/systementities/${row.id}`);
				}}
				noDataText="No system entities connected to this company."
			/>
			<HStack fullWidth justify="flex-start">
				<Button
					text={'Create system entity'}
					onClick={() => navigate('/systementities/create')}
					type="button"
				/>
			</HStack>
		</>
	);
};

export default SystemEntitiesList;
